import Layout from "../Shared/Layout";
import Banner from "./Banner";
import ClientsReviews from "./ClientsReviews";
import ClientsVideo from "./ClientsVideo";
import OurCategories from "./OurCategories";
import SafePayment from "./SafePayment";
import ShopProducts from "./ShopProducts";

const Home = () => {
    return (
        <Layout showBreadcrumb={false}>
            <Banner />
            <OurCategories />
            <ShopProducts />
            <ClientsReviews />
            {/* <ClientsVideo /> */}
            <SafePayment />
        </Layout>

    )
}

export default Home;
